import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-[#F5EDE4] py-16 px-4" data-id="element-116">
      <div className="max-w-2xl mx-auto text-center" data-id="element-117">
        <div className="bg-[#FDF8F3] rounded-2xl shadow-lg p-8 sm:p-10 border-2 border-[#B8C9B0]" data-id="element-118">
          <ShieldCheckIcon className="w-16 h-16 text-[#8B9E7E] mx-auto mb-6" data-id="element-119" />
          <h2 className="text-2xl font-bold text-[#5C4033] mb-4" data-id="element-120">
            🛡️ GARANTÍA SIN RIESGO
          </h2>
          <p className="text-lg text-[#8B7355] mb-4" data-id="element-121">
            Tenés <span className="font-bold" data-id="element-122">7 días</span> para probar todo el
            material.
          </p>
          <p className="text-lg text-[#8B7355]" data-id="element-123">
            Si sentís que no es para vos, si no te ayuda, si no cumple lo
            prometido…
            <br data-id="element-124" />
            <span className="font-bold text-[#8B9E7E] block mt-2" data-id="element-125">
              👉 Te devolvemos el 100% de tu dinero.
            </span>
          </p>
          <p className="text-sm text-[#8B7355]/80 mt-4" data-id="element-126">
            Sin preguntas. Sin vueltas.
          </p>
        </div>
      </div>
    </section>;
}